import React from "react";
import { SubscriptionsApi } from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { renderSubscriptionMoney } from "./utils";

interface Props {
	original: SubscriptionsApi;
	compare: SubscriptionsApi;
	renderOnlyCurrentSubscription?: boolean;
	renderOnlyPreviousSubscription?: boolean;
}

const SubscriptionSummaryPreviewTotals = ({
	original,
	compare,
	renderOnlyPreviousSubscription,
	renderOnlyCurrentSubscription,
}: Props) => {
	const renderAll = !renderOnlyPreviousSubscription && !renderOnlyCurrentSubscription;

	if (renderAll) {
		return (
			<div className={"row no-gutters"}>
				<div className={"col mb-3 original-app"}>
					<h5 className="mb-0">Kwota netto:</h5>
				</div>
				<div className={"col mb-3 original-price text-end"}>
					{original ? (
						<>
							{original.totals.map((total, index) => {
								if (index === 0) {
									return (
										<h6 key={total.billing_period} className="mb-0">
											{renderSubscriptionMoney(total.billing_period, total.total_price)}
										</h6>
									);
								}
								return (
									<p key={total.billing_period} className="mb-0">
										{renderSubscriptionMoney(total.billing_period, total.total_price)}
									</p>
								);
							})}
						</>
					) : (
						<h6 className="mb-0">~</h6>
					)}
				</div>
				<div className={"col mb-3 compare-app"}>
					<h5 className="mb-0">Kwota netto:</h5>
				</div>
				<div className={"col mb-3 compare-price text-end"}>
					{compare ? (
						<>
							{compare.totals.map((total, index) => {
								if (index === 0) {
									return (
										<h6 key={total.billing_period} className="mb-0">
											{renderSubscriptionMoney(total.billing_period, total.total_price)}
										</h6>
									);
								}
								return (
									<p key={total.billing_period} className="mb-0">
										{renderSubscriptionMoney(total.billing_period, total.total_price)}
									</p>
								);
							})}
						</>
					) : (
						<h6 className="mb-0">~</h6>
					)}
				</div>
			</div>
		);
	}

	if (renderOnlyPreviousSubscription) {
		return (
			<div className={"row no-gutters"}>
				<div className={"col mb-3 original-app"}>
					<h5 className="mb-0">Kwota netto:</h5>
				</div>
				<div className={"col mb-3 original-price text-end"}>
					{original ? (
						<>
							{original.totals.map((total, index) => {
								if (index === 0) {
									return (
										<h6 key={total.billing_period} className="mb-0">
											{renderSubscriptionMoney(total.billing_period, total.total_price)}
										</h6>
									);
								}
								return (
									<p key={total.billing_period} className="mb-0">
										{renderSubscriptionMoney(total.billing_period, total.total_price)}
									</p>
								);
							})}
						</>
					) : (
						<h6 className="mb-0">~</h6>
					)}
				</div>
			</div>
		);
	}

	if (renderOnlyCurrentSubscription) {
		return (
			<div className={"row no-gutters"}>
				<div className={"col mb-3 compare-app"}>
					<h5 className="mb-0">Kwota netto:</h5>
				</div>
				<div className={"col mb-3 compare-price text-end"}>
					{compare ? (
						<>
							{compare.totals.map((total, index) => {
								if (index === 0) {
									return (
										<h6 key={total.billing_period} className="mb-0">
											{renderSubscriptionMoney(total.billing_period, total.total_price)}
										</h6>
									);
								}
								return (
									<p key={total.billing_period} className="mb-0">
										{renderSubscriptionMoney(total.billing_period, total.total_price)}
									</p>
								);
							})}
						</>
					) : (
						<h6 className="mb-0">~</h6>
					)}
				</div>
			</div>
		);
	}

	return <></>;
};

export default SubscriptionSummaryPreviewTotals;
